import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { useCart } from '../context/CartContext';

const Header = () => {
  const location = useLocation();
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  // Don't show header on admin pages
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-rose-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src="https://customer-assets.emergentagent.com/job_studio-builder-12/artifacts/72mg2eao_%40theelenistudio.png"
              alt="Eleni Studio"
              className="w-12 h-12 group-hover:scale-110 transition-transform"
            />
            <span className="text-2xl font-serif text-rose-900 group-hover:text-rose-700 transition-colors">
              Eleni Studio
            </span>
          </Link>

          <nav className="flex items-center gap-6">
            <Link
              to="/"
              className="text-rose-800 hover:text-rose-600 font-medium transition-colors"
            >
              Collection
            </Link>
            <Link to="/cart" className="relative">
              <Button
                variant="outline"
                size="sm"
                className="relative border-rose-300 text-rose-800 hover:bg-rose-50 hover:text-rose-900"
              >
                <ShoppingCart className="w-5 h-5" />
                {cartCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-rose-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </Button>
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
